import { render, staticRenderFns } from "./userPolicy.vue?vue&type=template&id=58527fa2"
import script from "./userPolicy.vue?vue&type=script&lang=js"
export * from "./userPolicy.vue?vue&type=script&lang=js"
import style0 from "./userPolicy.vue?vue&type=style&index=0&id=58527fa2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports